import { render } from "./HelpCard.vue?vue&type=template&id=067a1d00"
import script from "./HelpCard.vue?vue&type=script&lang=js"
export * from "./HelpCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HelpCard.vue"]])

export default __exports__